import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { StatoManutenzione } from 'src/app/models/stato-manutenzione';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'stati-manutenzione-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class StatiManutenzioneFormComponent extends BaseEditForm implements OnInit {

  statoManutenzione: StatoManutenzione;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<StatiManutenzioneFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: StatoManutenzione,) {
    super();
    this.statoManutenzione = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.statoManutenzione?.nome, Validators.required],
    });
  }

}

